module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Y White.d3f0b95f.png";